import script from "./feedbackView.vue?vue&type=script&setup=true&lang=js"
export * from "./feedbackView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__